import React, { useState } from 'react'
import { Button, Input, Space, Switch, Typography } from 'antd';
const { Text, Title } = Typography;

const Address = ({ shipmentAddress, setShipmentAddress }) => {
    const [editAddress, setEditAddress] = useState(false)
    const [alternateAddress, setAlternateAddress] = useState({ ...shipmentAddress })
    const changeAddress = (event) => {
        const { name, value } = event.target;
        setAlternateAddress(prevAdd => ({ ...prevAdd, [name]: value }))
    }
    return (
        <div className='my-2 border border-1 rounded-4 p-3'>
            <div className='d-flex justify-content-between px-1'>
                <Title className='my-1' level={5}>Address</Title>
                <span className='d-flex align-items-center gap-2'>
                    <Switch value={editAddress} onChange={(value) => { setEditAddress(value) }} />
                    <Text>Use Alternate Address</Text>
                </span>
            </div>
            <Space.Compact block className='my-2'>
                <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '17%' }}
                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                    <Text>Locality </Text>
                </span>
                <Input defaultValue={shipmentAddress.locality} name='locality' disabled={!editAddress} onChange={changeAddress} />
            </Space.Compact>
            <div className='d-flex justify-content-between gap-2' style={{ width: '100%' }}>
                <Space.Compact block className='my-2'>
                    <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                        className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                        <Text>Landmark </Text>
                    </span>
                    <Input style={{ width: '70%' }} defaultValue={shipmentAddress.landmark} name='landmark' disabled={!editAddress} onChange={changeAddress} />
                </Space.Compact>
                <Space.Compact block className='my-2'>
                    <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                        className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                        <Text>City </Text>
                    </span>
                    <Input style={{ width: '70%' }} defaultValue={shipmentAddress.city} name='city' disabled={!editAddress} onChange={changeAddress} />
                </Space.Compact>
            </div>
            <div className='d-flex justify-content-between gap-2' style={{ width: '100%' }}>
                <Space.Compact block className='my-2'>
                    <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                        className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                        <Text>State </Text>
                    </span>
                    <Input style={{ width: '70%' }} defaultValue={shipmentAddress.state} name='state' disabled={!editAddress} onChange={changeAddress} />
                </Space.Compact>
                <Space.Compact block className='my-2'>
                    <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                        className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                        <Text>Pincode</Text>
                    </span>
                    <Input style={{ width: '70%' }} defaultValue={shipmentAddress.pincode} name='pincode' disabled={!editAddress} onChange={changeAddress} />
                </Space.Compact>
            </div>
            <div className='d-flex justify-content-end my-2'>
                <Button
                    onClick={() => {
                        setShipmentAddress(alternateAddress);
                        setEditAddress(false)
                    }}
                    disabled={!editAddress}>
                    Update Address
                </Button>
            </div>
        </div>
    )
}

export default Address